import Product from '@/pages/Sellpoint/Product'
import Sellpoint from '@/pages/Sellpoint/Sellpoint'
import Post from '@/pages/Sellpoint/Post'
import Gallery from '@/pages/Sellpoint/Gallery'
// import SellpointTemplate from '@/pages/Sellpoint/SellpointTemplate'
export default {
    path: '/:id',
    component: Sellpoint,
    children: [
        //commented out since the main Sellpoint is the base Template
    //   {
    //     path: '',
    //     name: 'Sellpoint',
    //     component: Sellpoint
    //   },
      {
        path: ':idp',
        name: 'Product',
        component: Product,
      },
      {
        path: 'p/:idpos',
        name: 'Post',
        component: Post,
      },
      {
        path: 'g/:idg',
        name: 'Gallery',
        component: Gallery,
      }
    ]
}


// WEBPACK FOOTER //
// ./src/router/sellpoint.js